import type { BaseComponentProps } from '@coursera/cds-common';

import Delayed from '@core/Delayed';
import type {
  InlineNotificationProps,
  InlineNotification,
} from '@core/notifications';

import getNotificationViewCss from './styles/getNotificationViewCss';

export type Props = BaseComponentProps<'div'> & {
  children: React.ReactElement<
    InlineNotificationProps,
    typeof InlineNotification
  >;
};

const NotificationView = (props: Props) => {
  const { children, ...rest } = props;
  return (
    <div
      aria-live="polite"
      css={getNotificationViewCss}
      role="region"
      {...rest}
    >
      <Delayed>{children}</Delayed>
    </div>
  );
};

export default NotificationView;
